import React, { useContext } from 'react';

import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { DATABASE_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component.ts';

import type { ContentPrerequisitesProps } from './ContentPrerequisites.tsx';
import { ContentPrerequisites } from './ContentPrerequisites.tsx';

type DatabasePrerequisitesProps = Pick<
	ContentPrerequisitesProps,
	'children' | 'contentQueryResult' | 'route'
>;

export const DatabasePrerequisites = ({
	children,
	contentQueryResult,
	route,
}: DatabasePrerequisitesProps): React.JSX.Element => {
	const experienceTracker = useContext(ExperienceTrackerContext);

	const handleUnexpectedError = (error: Error) => {
		experienceTracker.fail({
			name: DATABASE_EXPERIENCE,
			error,
		});
		getMonitoringClient().submitError(error, {
			attribution: Attribution.CONTENT_TYPES,
		});
		markErrorAsHandled(error);
	};

	return (
		<ContentPrerequisites
			route={route}
			contentQueryResult={contentQueryResult}
			passThroughOnLoading
			handleUnexpectedError={handleUnexpectedError}
		>
			{children}
		</ContentPrerequisites>
	);
};
